import { POSTAPICALL } from "../API/Axios";
import {  getExpiryTime, getUserId, getUserName, isLoggedin, setExpiryTime } from "./GetUserData";
import showMessage from "./Toast";
import configData from "../config.json";
import Cookies from "js-cookie";

export const HandleLogout = () =>{
  const req = {
    USERNAME : getUserId()
  }
  POSTAPICALL(configData.LOGOUT,req).then(
    (res)=>{
      window.location.replace("/");
    }
  ).catch(
    (err)=>console.log(err)
  )
      sessionStorage.clear();
      try{
      window.removeEventListener("click",UpdateExpiryTime);
      window.removeEventListener("keypress",UpdateExpiryTime);
      window.removeEventListener("scroll",UpdateExpiryTime);
      window.removeEventListener("mousemove",UpdateExpiryTime);
      }
      catch(exception){
        console.log(exception);
        window.location.replace("/");
      }
}

export const UpdateExpiryTime = () =>{
    if(isLoggedin()){
    const expiryTime = Date.now() + 900000; //15 Minutes
    setExpiryTime(expiryTime);
    }
  }

 export const CheckForInActivity = () =>{
    const ExpiryTime = getExpiryTime();
    if( ExpiryTime < Date.now())
    { 
      showMessage("Logging out due to inactivity","w");
      HandleLogout();
    }
  }